import { useState, useEffect } from "react";
import { loadScript } from "../../../../../../globals/constants";
import apiCall from "../../../../../../apicall";
import { useSelector } from "react-redux";
import Toast from "../../../../../common/toast";
import { useLocation } from "react-router-dom";
import { logEvent_Analytics } from "../../../../../common/firebase/firebase-analytics-service";
import { downloadJobHistoryCSV } from "../../../../candidate/components/export-csv/download-reports-csv";
import CanJobsCalendarList from "./cab-jobs-calendar-list";
import SectionJobsSidebar1 from "../../../sections/jobs/sidebar/section-jobs-sidebar1";
import moment from "moment";

function CandidateAllJobsCalendarView() {
  const { TOKEN, isAddressSelected, selectedCategoryType } = useSelector(
    (state) => state.menu
  );
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [jobListData, setJobListData] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    status: "All",
    applicant: "",
    customer: "",
    fromDate: "",
    toDate: "",
    sortType: "recentJobs",
    sortDirection: "desc",
    searchKey: "",
    jobType: "",
    applicant: "",
    customer: "",
    company: "",
    locationName: isAddressSelected?.locationName
      ? isAddressSelected?.locationName
      : "",
    lat: isAddressSelected?.latlng ? isAddressSelected?.latlng?.lat : "",
    lng: isAddressSelected?.latlng ? isAddressSelected?.latlng?.lng : "",
    jobStatus: "eOpen",
    categoryType: selectedCategoryType ? selectedCategoryType : "All",
  });
  const [sliderValue, setSliderValue] = useState(() => {
    const savedValue = localStorage.getItem("sliderValue");
    return savedValue !== null ? JSON.parse(savedValue) : 100;
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0,
  });
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [queryParams, setQueryParams] = useState(
    `&month=${moment().format("YYYY-MM")}`
  );

  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    setIsLoading(false);
    setJobListData([]);
    setPaginationData({
      totalElements: 0,
      totalPages: 0,
    });
  };

  const dispErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
  };

  const fetchjobList = async () => {
    try {
      setIsLoading(true);

      const baseQuery = `latitude=${tableFilter?.lat}&longitude=${
        tableFilter?.lng
      }&category=${tableFilter?.categoryType}&sortBy=${
        tableFilter?.sortType
      }&sortDirection=${tableFilter?.sortDirection}&offset=0&page=${
        currentPage - 1
      }&size=${rowPerPage}&company=${tableFilter?.company}&searchKey=${
        tableFilter?.searchKey
      }${queryParams}`;

      const api1 = `jobs/allCalendarOpen?jobStatus=eOpen&distance=${sliderValue}&locationLat=${tableFilter?.lat}&locationLong=${tableFilter?.lng}&${baseQuery}`;
      const api2 = `jobs/allCalendarApplied?jobEntity.jobStatus=eInProgress&jobEntity.jobStatus=eCancelled&jobEntity.jobStatus=eAccepted&jobEntity.jobStatus=eCompleted&jobEntity.jobStatus=eApplied&hired=true&${baseQuery}`;

      const [res1, res2] = await Promise.all([
        apiCall(api1, "GET", null, TOKEN),
        apiCall(api2, "GET", null, TOKEN),
      ]);

      console.log("response===", res1, res2)
      const content1 = res1?.data || [];
      const content2 = res2?.data || [];

      const mergedJobs = [...content1, ...content2];

      if (mergedJobs?.length > 0) {
        setJobListData(mergedJobs);
        setPaginationData({
          totalElements: mergedJobs?.length,
          totalPages: Math.ceil(mergedJobs?.length / rowPerPage),
        });
      } else if (mergedJobs?.length === 0) {
        setJobListData([]);
        setPaginationData({
          totalElements: 0,
          totalPages: 0,
        });
      } else {
        displayErrMsg(res1?.response?.data?.message);
      }
    } catch (error) {
      displayErrMsg("Network Error!");
      console.error("Error fetching job data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadScript("js/custom.js");
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const savedValue = localStorage.getItem("sliderValue");
      if (savedValue !== null) {
        setSliderValue(JSON.parse(savedValue));
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    fetchjobList();
  }, [currentPage, tableFilter, rowPerPage, queryParams]);

  useEffect(() => {
    logEvent_Analytics("Calendar_web");
  }, [location?.pathname]);

  return (
    <>
      <div className="section-full p-t120  p-b90 site-bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12 rightSidebar">
              <SectionJobsSidebar1
                setTableFilter={setTableFilter}
                tableFilter={tableFilter}
                setCurrentPage={setCurrentPage}
                applicantList={[]}
                dispErrMsg={dispErrMsg}
              />
            </div>
            <div className="col-lg-8 col-md-12">
              <div class="col-lg-12 col-md-12 col-sm-12 panel-heading wt-panel-heading p-a20 d-flex">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <h3 class="wt-title mt-4">All Jobs Calendar View</h3>
                </div>
              </div>
              <CanJobsCalendarList
                isLoading={isLoading}
                jobListData={jobListData}
                setQueryParams={setQueryParams}
              />
            </div>
          </div>
        </div>
      </div>
      {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""}
    </>
  );
}

export default CandidateAllJobsCalendarView;
